import useSwr from "@/core/composables/swr/useSwr";
import {computed} from "vue";
import {cacheKey} from "@/lib/cache";
import {massCertificationApi} from "@/container";

const useMassCertificationBatches = (params: {
    page?: number,
    limit?: number,
    targetable?: {type: string, id: number}
}) => {
    const key = computed(() => {
        return cacheKey(`mass-certification/batches`, params);
    });

    return useSwr(
        key,
        () => massCertificationApi().indexBatches(params.page, params.limit, params.targetable),
    );
};

export default useMassCertificationBatches;
